import { Clock, FileText, ShoppingCart, TrendingUp, TriangleAlert } from "lucide-react";

const ICONS = { orders: ShoppingCart, docs: FileText, money: TrendingUp, due: Clock,
                alert: TriangleAlert };

// نغمات موسّعة لتجنّب تكرار الألوان داخل الصفحة الواحدة (11 نغمة زاهية).
const TONES = {
  sky:     "bg-sky-500",
  emerald: "bg-emerald-500",
  amber:   "bg-amber-500",
  rose:    "bg-rose-500",
  violet:  "bg-violet-500",
  indigo:  "bg-indigo-500",
  teal:    "bg-teal-500",
  fuchsia: "bg-fuchsia-500",
  orange:  "bg-orange-500",
  cyan:    "bg-cyan-500",
  lime:    "bg-lime-500",
  // أليس قديم (توافق للخلف)
  neutral: "bg-sky-500", good: "bg-emerald-500", warn: "bg-amber-500", bad: "bg-rose-500",
};

const CARD_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};
const VALUE_3D = {
  textShadow:
    "0 1px 0 rgba(0,0,0,0.20), 0 2px 0 rgba(0,0,0,0.16), 0 3px 0 rgba(0,0,0,0.12), 0 6px 12px rgba(0,0,0,0.40)",
};

// بطاقة مؤشّر بلون كامل + بروز 3D (يجب أن تكون النغمة فريدة لكل بطاقة داخل نفس الصفحة).
export const StatCard = ({ label, value, icon = "docs", tone = "sky", testid }) => {
  const Icon = ICONS[icon] || FileText;
  const surface = TONES[tone] || TONES.sky;
  return (
    <div data-testid={testid} style={CARD_3D}
         className={`animate-rise-in flex items-center justify-between gap-3 rounded-3xl p-4 text-white ${surface}`}>
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white/25 text-white drop-shadow-[0_4px_6px_rgba(0,0,0,0.30)]">
        <Icon className="h-5 w-5" />
      </span>
      <div className="min-w-0 text-end">
        <p className="truncate text-[11px] font-bold uppercase tracking-wide text-white/85">{label}</p>
        <p className="num font-mono text-xl font-black text-white" style={VALUE_3D}>{value}</p>
      </div>
    </div>
  );
};
